import React, { PureComponent } from "react";
import { Router, Route, Switch } from "react-router-dom";
import { createHashHistory } from "history";
import App from "../App";

const hist = createHashHistory();

class IndexRoutes extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // 多语言message,默认为中文
  render() {
    // 根路由绑定APP Component
    const indexRoutes = [
      {
        path: "/",
        component: App,
      },
    ];

    return (
      <Router history={hist}>
        <Switch>
          {indexRoutes.map((prop, key) => {
            return <Route path={prop.path} component={prop.component} key={key} />;
          })}
        </Switch>
      </Router>
    );
  }
}

export default IndexRoutes;



// WEBPACK FOOTER //
// ./src/AntD/routes/indexRoutes.js